import React from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #2D3653;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 15px;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  height: calc(100% - 40px);
`;

const QrCodeWrapper = styled.div`
  background: white;
  padding: 10px;
  border-radius: 8px;
  flex-shrink: 0;
`;

const TextContent = styled.div`
  flex: 0 1 auto;
  font-family: 'Poppins', sans-serif;
  font-size: clamp(12px, 1vw, 16px);
  line-height: 1.5;
  padding-right: 10px;
  display: block;
  text-align: left;

  p {
    margin: 0;
    padding: 0;
  }

  ol {
    margin: 0;
    padding-left: 20px;
    list-style-position: outside;
  }

  li {
    margin: 0;
    padding: 0;
  }
`;

const QrCodeContainer = ({ qrCode, qrCodeText, title }) => {
  return (
    <Container>
      <ContentWrapper>
        {qrCode && (
          <QrCodeWrapper>
            <QRCodeSVG
              value={qrCode}
              size={100}
              level="H"
              includeMargin={false}
            />
          </QrCodeWrapper>
        )}
        {qrCodeText && (
          <TextContent dangerouslySetInnerHTML={{ __html: qrCodeText }} />
        )}
      </ContentWrapper>
    </Container>
  );
};

export default QrCodeContainer; 